import { render, staticRenderFns } from "./EditBlock.vue?vue&type=template&id=f1750e6a&"
import script from "./EditBlock.vue?vue&type=script&lang=js&"
export * from "./EditBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports